"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactApollo = require("react-apollo");

var _commonReact = require("@devsta/common-react");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function ManageAsset(_ref) {
  var isVisible = _ref.isVisible,
      assetId = _ref.assetId,
      handleClose = _ref.handleClose,
      handleError = _ref.handleError,
      handleSave = _ref.handleSave;
  return _react.default.createElement(_reactApollo.ApolloConsumer, null, function (apolloClient) {
    return _react.default.createElement(_commonReact.ManageAssetModal, {
      isVisible: isVisible,
      assetId: assetId,
      apiClient: apolloClient,
      onError: handleError,
      onClose: handleClose,
      onSave: handleSave
    });
  });
}

var _default = (0, _react.memo)(ManageAsset);

exports.default = _default;